// src/pages/settings/NotificationSettingsPage.jsx
import React, { useState, useEffect } from 'react';
import PageHeader from 'components/common/PageHeader';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'components/ui/card';
import { Switch } from 'components/ui/switch';
import { Label } from 'components/ui/label';
import { Volume2, VolumeX } from 'lucide-react';
import { toast } from 'sonner';

const SettingsPage = () => {
    const [soundEnabled, setSoundEnabled] = useState(true);

    useEffect(() => {
        const saved = localStorage.getItem("notificationSoundEnabled");
        setSoundEnabled(saved === null || saved === "true");
    }, []);

    const toggleSound = () => {
        const newValue = !soundEnabled;
        setSoundEnabled(newValue);
        localStorage.setItem("notificationSoundEnabled", newValue);
        toast.success(newValue ? "Notification sound enabled" : "Notification sound disabled");
    };

    return (
        <div className="space-y-6 animate-fade-in">
            <PageHeader
                title="Notification Settings"
                description="Control notification sound"
            />

            <div className="mx-auto">
                <Card>
                    <CardHeader>
                        <CardTitle className="flex items-center gap-3">
                            <Volume2 className="w-6 h-6" />
                            Sound Preferences
                        </CardTitle>
                        <CardDescription>
                            Turn notification sound on or off
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <div className="flex items-center justify-between p-6 rounded-lg border bg-card">
                            <div className="flex items-center gap-4">
                                {soundEnabled ?
                                    <Volume2 className="w-8 h-8 text-green-600" /> :
                                    <VolumeX className="w-8 h-8 text-destructive" />
                                }
                                <div>
                                    <Label htmlFor="sound-toggle" className="text-lg font-medium cursor-pointer">
                                        Notification Sound
                                    </Label>
                                    <p className="text-sm text-muted-foreground">
                                        {soundEnabled ? "Sound will play on new notifications" : "Notifications will be silent"}
                                    </p>
                                </div>
                            </div>
                            <Switch
                                id="sound-toggle"
                                checked={soundEnabled}
                                onCheckedChange={toggleSound}
                                className="scale-125"
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default SettingsPage;